import React from 'react';
import styled from 'styled-components';
import { Typo, Icon as _Icon } from 'tmt-ui-kit';

const Text = styled(Typo.Paragraph)`
  font-size: 16px !important;
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 52px 0;

  @media(max-width: 600px) {
    flex-direction: column;
    padding:0px 16px;
  }
`;

const ItemContainer = styled.div`
  width: fit-content;
  @media(max-width: 1000px) {
    margin: 0 auto;
  }
  @media(max-width: 600px) {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 40px;
  }
`;

const TextItem = styled(Text)`
  color: ${props => props.theme.greenLighter} !important;
  font-weight: 600 !important;
  text-align: left;

  @media(max-width: 600px) {
    text-align: left;
    width: 100%;

    br {
      display: none;
    }
  }
`;

const Icon = styled(_Icon)`
  display: block;
  font-size: 86px;
  color: ${props => props.theme.greenLighter};
  width: 86px;
  height: fit-content;
`;

const IconContainer = styled.div`
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: -14px;
  margin-bottom: 18px;

  @media(max-width: 600px) {
    margin: 0;
    align-items: flex-end;
    margin-right: 20px;
  }
`;

const Detail = () => {
  return (
    <Container>
      <ItemContainer>
        <IconContainer>
          <div>
            <Icon name="thai-house" />
          </div>
        </IconContainer>
        <div>
          <TextItem>Local Stories</TextItem>
          <Text>Discover untold stories <br/>from local friends</Text>
        </div>
      </ItemContainer>
      <ItemContainer>
        <IconContainer>
          <div>
            <Icon name="clock-11" />
          </div>
        </IconContainer>
        <div>
          <TextItem>Flexible</TextItem>
          <Text>Stick to your <br/>own pace</Text>
        </div>
      </ItemContainer>
      <ItemContainer>
        <IconContainer>
          <div>
            <Icon name="volunteer" />
          </div>
        </IconContainer>
        <div>
          <TextItem>Full Support</TextItem>
          <Text>Free 1-day local tour <br/>from TakeMeTour</Text>
        </div>
      </ItemContainer>
    </Container>
  );
};

export default Detail;
